<div class="container">
  <div class="imageContainer">
    <img
      class="mt-5"
      height="50"
      width="50"
      alt="selected bank logo"
      [src]="selectedBank?.logo?.value"
    />
    <p class="imageText text-center">
      {{ "webauth_waiting_login_to_external_bank" | translate }}
      {{ selectedBank?.name }}
    </p>
  </div>

  <div class="spinningContainer">
    <app-lottie-loader [height]="'50px'" [color]="'BLACK'"></app-lottie-loader>
    <p class="spinningText">
      {{ "redirect_to_external_bank_wait" | translate : {bankName: selectedBank?.name } }}
    </p>
  </div>
</div>
